import { useCallback, useRef } from 'react';

import { SendMessageModal } from '@app/features/SendoutCreationModal/components/SendMessageModal';
import type { NSendMessageModal } from '@app/features/SendoutCreationModal/components/SendMessageModal/SendMessageModal.types';

export const useSendout = () => {
  const sendMessageModalRef =
    useRef<NSendMessageModal.SendMessageModalApi>(null);
  const renderSendMessageModal = useCallback(
    () => <SendMessageModal ref={sendMessageModalRef} />,
    []
  );
  const openSendMessageModal = useCallback<
    NSendMessageModal.SendMessageModalApi['open']
  >((data, onSuccessCb) => {
    sendMessageModalRef.current?.open(data, onSuccessCb);
  }, []);

  return {
    openSendMessageModal,
    renderSendMessageModal,
  };
};
